import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import LoginButton from '../../components/login-button';
import EmptyStates from '../../components/empty-states';
import withTranslate from '../../hoc/with-translate';
import styles from './restriction.scss';

const Restriction = ({ t }) =>
  <EmptyStates
    className={classNames(styles.emptyStates, 'restriction')}
    title={t('restriction.title')}
    content={t('restriction.content')}
  >
    <LoginButton/>
  </EmptyStates>;

Restriction.propTypes = {
  t: PropTypes.func,
};

export default withTranslate(Restriction);



// WEBPACK FOOTER //
// ./app/components/restriction/restriction.js